module.exports = __webpack_public_path__ + "static/media/golfer-8-b.01fd6a0f.png";